import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsTextareaComponent } from "./ds-textarea.component";

@NgModule({
  declarations: [DsTextareaComponent],
  imports: [CommonModule],
  exports: [DsTextareaComponent],
})
export class DsTextareaModule {}
